import * as z from 'zod';

export const skuQuerySchema = z.object({
  id: z.number(),
  sku: z.string(),
  pivot: z.object({
    primary: z.number(),
  }),
  // extra fields
  intent: z.union([z.literal('create'), z.literal('delete'), z.literal('update')]).optional(),
  // localMatchId is used to match sku in create case
  localMatchId: z.number().optional(),
  // helps when add new sku in update list
  setDirtyHelper: z.boolean().optional(),
});

export type SKUQuerySchema = z.infer<typeof skuQuerySchema>;
export const skusQuerySchema = z.array(skuQuerySchema);

export const skuCreateFormSchema = skuQuerySchema;
export type SKUCreateFormSchema = z.infer<typeof skuCreateFormSchema>;

export const skuFormSchema = skuQuerySchema.omit({ sku: true }).extend({
  sku: z.string().min(3), // must be 1
});

export type SKUFormSchema = z.infer<typeof skuFormSchema>;

// let duplicateskuPlaces: string[] = [];
export const dummySKUsQuerySchema = z
  .object({
    skus: z.array(skuFormSchema),
  })
  .superRefine(({ skus }, ctx) => {
    const places: string[] = [];
    const skuCounts = skus.reduce(
      (acc, sku, index) => {
        if (!acc[sku.sku]) {
          acc[sku.sku] = [];
        }
        acc[sku.sku].push(index);
        return acc;
      },
      {} as Record<string, number[]>
    );

    const duplicateIndexes = Object.values(skuCounts)
      .filter((indexes) => indexes.length > 1)
      .flat();
    places.push(...duplicateIndexes.map((index) => index.toString()));
    for (let i = 0; i < places.length; i++) {
      ctx.addIssue({
        code: 'custom',
        message: 'SKU already exists.',
        fatal: true,
        path: [`skus.${places[i]}.sku`],
      });
    }
  });

export const skusMutationSchema = skuQuerySchema.pick({ sku: true, id: true });
export type SKUsMutationSchema = z.infer<typeof skusMutationSchema>;

export const skusLinkerMutationSchema = z.array(
  z.object({
    sku_id: z.number(),
    primary: z.boolean(),
  })
);

export function hasDuplicates(a: string[]) {
  const noDups = new Set(a);
  return a.length !== noDups.size;
}
